import { render, staticRenderFns } from "./QLMateriali.vue?vue&type=template&id=6299d6f8&scoped=true&"
import script from "./QLMateriali.vue?vue&type=script&lang=js&"
export * from "./QLMateriali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6299d6f8",
  null
  
)

export default component.exports